<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">

      <b-form @submit.prevent="submitForm(false)">
        <b-card-header class="border-0 pl-0">
          <h3 class="mb-0"> {{ $t('nuevo_ingreso') }} </h3>
        </b-card-header>
        <b-row class="card-ing">
          <b-col md="12">
            <b-row>
              <!--b-col md="2" class="ai-c">
                <b-form-radio-group v-model="form.Tipo" name="tipo">
                  <b-form-radio value="O">{{ $t('origen') }}</b-form-radio>
                  <b-form-radio value="D">{{ $t('destino') }}</b-form-radio>
                </b-form-radio-group>
              </b-col-->

              <b-col md="2">
                <b-form-group label="Pais" label-for="paisID">
                  <template v-slot:label>
                    {{ $t('pais') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="paisID" @change="onChangePais" v-model="form.PaisID" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in paisOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group label="Fecha" label-for="fecha">
                  <template v-slot:label>
                    {{ $t('fecha') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="fecha" type="date" v-model="form.Fecha" ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="6">
            <b-row class="mb-2">
              <strong>1. {{ $t('origen') }}</strong>
            </b-row>

            <b-row>
              <b-col md="4">
                <b-form-group label="Empresa Origen" label-for="empresaID">
                  <template v-slot:label>
                    {{ $t('empresa') + ' ' + $t('origen') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="empresaID" :disabled="!isPaisSelected" v-model="form.EmpresaID"
                    @change="onEmpresaOrigenChange" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in empresaOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Origen" label-for="plantaOrigenID">
                  <template v-slot:label>
                    {{ $t('planta') + ' ' + $t('origen') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="plantaOrigenID" :disabled="!isEmpresaSelected" v-model="form.PlantaOrigenID"
                    @change="onPlantaOrigenChange" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in plantaOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Origen" label-for="pasilloOrigenID">
                  <template v-slot:label>
                    {{ $t('pasillo') + ' ' + $t('origen') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="pasilloOrigenID" :disabled="!isPlantaSelected" v-model="form.PasilloOrigenID"
                    >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in pasilloOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

            </b-row>
          </b-col>

          <b-col md="6">
            <b-row class="mb-2">
              <strong>2. {{ $t('transporte_origen') }}</strong>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group label="Chofer" label-for="choferID">
                  <template v-slot:label>
                    {{ $t('chofer') }} <span class="text-danger">*</span>
                  </template>
                  <b-input-group>
                    <el-select class="custom-input" v-model="form.ChoferID" filterable
                      :placeholder="$t('seleccione_opcion')" style="width: 85%;">
                      <el-option v-for="item in choferOptions" :key="item.value" :label="item.text" :value="item.value" />
                    </el-select>
        
                    <b-input-group-append>
                      <b-button
                        variant="primary"
                        size="sm"
                        class="btn-create-new"
                        style="margin-left: 10px;"
                        id="btnCrearChofer"
                        @click="showChoferModal = true"
                      >
                        <i class="ni ni-fat-add"></i>
                      </b-button>
                      <b-tooltip target="btnCrearChofer" placement="top">
                        {{ $t('agregar_chofer') }}
                      </b-tooltip>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group label-for="patente">
                  <template v-slot:label>
                    {{ $t('patente_camion') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="patente" v-model="form.Patente" 
                    maxlength="7"
                    placeholder="Ingrese la patente"></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group label-for="patente">
                  <template v-slot:label>
                    {{ $t('patente_carro') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="patente" v-model="form.PatenteCarro"  maxlength="7"
                    placeholder="Ingrese la patente"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="12">
            <b-row class="mb-2">
              <strong>3. {{ $t('destino') }}</strong>
            </b-row>
            <b-row>
              <b-col class="col-md-2">
                <b-form-group label="Empresa Destino" label-for="empresaDestinoID">
                  <template v-slot:label>
                    {{ $t('empresa') + ' ' + $t('destino') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="empresaDestinoID" :disabled="!isPaisSelected" v-model="form.EmpresaDestinoID"
                    @change="onEmpresaDestinoChange" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in empresaOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col class="col-md-2">
                <b-form-group label="Destino" label-for="plantaDestintoID">
                  <template v-slot:label>
                    {{ $t('planta') + ' ' + $t('destino') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="plantaDestintoID" :disabled="!isEmpresaDestinoSelected"
                    v-model="form.PlantaDestinoID" @change="onPlantaDestinoChange" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in plantaDestinoOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col class="col-md-2">
                <b-form-group label="Destino" label-for="pasilloDestintoID">
                  <template v-slot:label>
                    {{ $t('pasillo') + ' ' + $t('destino') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="pasilloDestintoID" :disabled="!isPlantaDestinoSelected"
                    v-model="form.PasilloDestinoID" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in pasilloDestinoOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

          </b-col>

          <b-col md="7">
            <b-row class="mb-2">
              <strong>4. {{ $t('guia_despacho') }}</strong>
            </b-row>
            <b-row>
              <b-col md-3>
                <b-form-group :label="$t('numero_folio')" label-for="folio">
                 <b-form-input id="folio" type="number" :disabled="!folioEnabled" v-model="form.NumeroFolio" :placeholder="$t('numero_folio')"></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md-3>
                <b-form-group label-for="nro_hoja">
                  <template v-slot:label>
                    {{ $t('numero_hoja') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="nro_hoja" v-model="form.NumeroHoja" 
                    :placeholder="$t('numero_hoja')"></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md-3>
                <b-form-group label-for="guiaTraslado">
                  <template v-slot:label>
                    {{ $t('guia_traslado') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="guiaTraslado" v-model="form.GuiaTraslado" 
                    :placeholder="$t('guia_traslado')"></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md-3>
                <b-form-group label="Monto g_traslado" label-for="MontoGuiaTraslado">
                  <template v-slot:label>
                    {{ $t('monto_guia_traslado') }}  
                    <span v-if="monedaOptions.find(t => t.value === form.MonedaID)">
                      ({{ monedaOptions.find(t => t.value === form.MonedaID).text }})
                    </span><span class="text-danger">*</span>
                  </template>
                 
                  <b-form-input id="MontoGuiaTraslado" type="text"
                    :value="$utilsService.getFormattedDecimal('MontoGuiaTraslado', form)"
                    @input="$utilsService.onInputDecimal('MontoGuiaTraslado', form, $event)"
                     :placeholder="$t('monto')"></b-form-input>
 

                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md-4>
                <b-form-group label="N° Ticket" label-for="ticket">
                  <b-form-input id="ticket" v-model="form.Ticket" :placeholder="$t('numero_ticket')"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group  label-for="ticketInex">
                  <template v-slot:label>
                    N° Ticket Inexlink <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="ticketInex" v-model="form.TicketInex" 
                    :placeholder="$t('numero_ticket_inexlink')"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group :label="$t('peso_neto')" label-for="peso">
                  <template v-slot:label>
                    {{ $t('peso_neto') }}
                    <span v-if="uomOptions.find(t => t.value === form.UomID)">
                      ({{ uomOptions.find(t => t.value === form.UomID).text }})
                    </span>
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="peso"
                    v-model="form.Peso"
                    type="text"
                    @keypress="onlyNumbers"          
                    @input="onInputCL('Peso', $event)"   
                    :placeholder="$t('peso_neto')">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group :label="$t('peso_neto_inexlink')" label-for="pesoInex">
                  <template v-slot:label>
                    {{ $t('peso_neto_inexlink') }}
                    <span v-if="uomOptions.find(t => t.value === form.UomID)">
                      ({{ uomOptions.find(t => t.value === form.UomID).text }})
                    </span>
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="pesoInex"
                    v-model="form.PesoInex"
                    type="text"
                    @keypress="onlyNumbers"
                    @input="onInputCL('PesoInex', $event)"
                    :placeholder="$t('peso_neto_inexlink')">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group :label="$t('motivo_no_conformidad')" label-for="noConformidad">
                  <template v-slot:label>
                    {{ $t('motivo_no_conformidad') }}
                  </template>
                  <b-form-select id="noConformidadID" v-model="form.NoConformidadID">
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in conformidadOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

              <b-row>
              <b-col md-4>
                <b-form-group :label="$t('comentarios_no_conformidad')" label-for="comentarios">
                  <b-form-textarea id="comentarios" v-model="form.Comentarios"
                    :placeholder="$t('comentarios_no_conformidad')"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="5">
            <b-row class="mb-2">
              <strong>5. {{ $t('materiales') }}</strong>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label="Material Recibido" label-for="materialID">
                  <template v-slot:label>
                    {{ $t('material_recibido') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="materialID" v-model="form.MaterialID" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in materialOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group label="Uom" label-for="uomID">
                  <template v-slot:label>
                    {{ $t('uom') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="uomID" v-model="form.UomID" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in uomOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          
          </b-col>

          <b-col md="8">
            <b-row class="mb-2">
              <strong>6. {{ $t('valor') }}</strong>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label="Precio" label-for="precio">
                  <template v-slot:label>
                    {{ $t('precio') }}
                    <span v-if="monedaOptions.find(t => t.value === form.MonedaID)">
                      ({{ monedaOptions.find(t => t.value === form.MonedaID).text }})
                    </span>
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="precio" :value="$utilsService.getFormattedDecimal('Precio', form)" @keypress="onlyNumbers"
                    @input="$utilsService.onInputDecimal('Precio', form, $event)" type="text"  
                    :placeholder="$t('precio')" />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Moneda" label-for="monedaID">
                  <template v-slot:label>
                    {{ $t('moneda') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="monedaID" v-model="form.MonedaID" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in monedaOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label-for="porcentaje">
                  <template v-slot:label>
                    {{ $t('porcentaje_producto') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="porcentaje" v-model="form.PorcentajeProducto"  type="number"
                    step="1" 
                    min="0" 
                    max="100"
                    placeholder="Ingrese la porcentaje"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group :label="$t('descuento')" label-for="descuento">
                  <b-form-input id="descuento" v-model="form.Descuento" type="number" step="any"
                    :placeholder="$t('descuento')"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group :label="$t('comentarios_descuento')" label-for="comentariosDescuento">
                  <b-form-textarea id="comentariosDescuento" v-model="form.ComentariosDescuento"
                    :placeholder="$t('comentarios_descuento')"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-button variant="danger" class="ml-2" @click="$router.go(-1)">
          <i class="fas fa-arrow-left"></i> {{ $t('cancelar') }}
        </b-button>
        <b-button type="submit" variant="primary">
          {{ $t('guardar') }}
        </b-button>
      </b-form>
    </base-header>

    <b-modal
      id="modal-crear-chofer"
      v-model="showChoferModal"
      title="Crear Chofer"
      size="lg"
      hide-footer
    >
      <ChoferCrear @close="showChoferModal = false" @created="onChoferCreated"/>
    </b-modal>
  </div>
</template>
<script>
import ingresoService from '@/api/ingresoService';
import miscService from '@/api/miscService';
import { Select, Option } from 'element-ui'
import folioService from '../../api/folioService.vue';
import ChoferCrear from '@/views/Chofer/CrearModal.vue';
import empresaService from '../../api/empresaService.vue';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ChoferCrear,
  },
  data() {
    return {
      form: {
        Patente: '',
        ChoferID: null,
        EmpresaID: null,
        EmpresaDestinoID: null,
        Fecha: '',
        MaterialID: null,
        GuiaTraslado: '',
        MontoGuiaTraslado: '',
        Peso: '',
        Ticket: '',
        PesoInex: '',
        TicketInex: '',
        Descuento: '',
        NoConformidadID: null,
        Comentarios: '',
        Precio: '',
        PesoTotal: '',
        NumeroFolio: null,
        NumeroHoja: null,
        MonedaID: null,
        UomID: null,
        PasilloOrigenID: null,
        PasilloDestinoID: null,
        PlantaOrigenID: null,
        PlantaDestinoID: null,
        PaisID: null,
        IsCompleted: true,
        skip: false
      },
      materialOptions: [],
      conformidadOptions: [],
      uomOptions: [],
      monedaOptions: [],
      empresaOptions: [],
      choferOptions: [],
      paisOptions: [],
      plantaOptions: [],
      plantaDestinoOptions: [],
      pasilloOptions: [],
      pasilloDestinoOptions: [],
      isEmpresaSelected: false,
      isEmpresaDestinoSelected: false,
      isPlantaSelected: false,
      isPlantaDestinoSelected: false,
      isPaisSelected: false,
      originalForm : null,
      showChoferModal: false,
      folioEnabled: false,
    };
  }, 
   beforeDestroy() {
    delete this.$globalMethods.submitForm;
  },
  async beforeMount() {
    const [
      choferOptions,
      empresaOptions,
      materialOptions,
      conformidadOptions,
      monedaOptions,
      uomOptions,
      paisOptions,
      folioValido
    ] = await Promise.all([
      miscService.getChoferesOptions(),
      miscService.getEmpresasOptions(),
      miscService.getMaterialesOptions(),
      miscService.getConformidadesOptions(),
      miscService.getMonedasOptions(),
      miscService.getUomsOptions(),
      miscService.getPaisesOptions(),
      folioService.getFolioValido()
    ]);

    this.choferOptions = choferOptions;
    this.empresaOptions = empresaOptions;
    this.materialOptions = materialOptions;
    this.conformidadOptions = conformidadOptions;
    this.monedaOptions = monedaOptions;
    this.uomOptions = uomOptions;
    this.paisOptions = paisOptions;
    this.form.NumeroFolio = folioValido >0? folioValido: null;
    //this.form.NumeroHoja = NumeroHoja > 0 ? NumeroHoja : null;
    this.form.NumeroHoja = null;
    
    this.originalForm = JSON.stringify(this.form); // Guarda el estado inicial del formulario
    localStorage.setItem('hasUnsavedChanges', 'false');
    this.$globalMethods.submitForm = this.submitForm;
  },  
  watch: {
    form: {
      handler() {
        // Compara el formulario actual con su estado inicial
        const hasChanges = JSON.stringify(this.form) !== this.originalForm;
        localStorage.setItem('hasUnsavedChanges', hasChanges.toString()); // Actualiza en localStorage
      },
      deep: true, // Observa cambios en propiedades anidadas
    },
  },
  beforeDestroy() {
    // Elimina el método de la instancia global
    delete this.$globalMethods.submitForm;
  },
  methods: {
    // Aplica formato chileno: miles con punto, decimal con coma
formatCLChilean(text) {
  if (!text) return '';
  // 1) Mantén solo dígitos y comas, y deja UNA sola coma (la primera)
  let t = String(text).replace(/[^0-9,]/g, '');
  const firstComma = t.indexOf(',');
  if (firstComma !== -1) {
    // elimina comas extra
    const left = t.slice(0, firstComma + 1);
    const right = t.slice(firstComma + 1).replace(/,/g, '');
    t = left + right;
  }

  // 2) Separa parte entera y decimal
  let entero = t, decimal = '';
  if (firstComma !== -1) {
    const parts = t.split(',');
    entero = parts[0];
    decimal = parts[1] || '';
  }

  // 3) Quita ceros a la izquierda (pero deja 0 si vacío)
  entero = entero.replace(/^0+(?=\d)/, '');
  if (entero === '') entero = '0';

  // 4) Aplica separador de miles con punto
  entero = entero.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  // 5) Reconstruye
  return decimal !== '' ? `${entero},${decimal}` : entero;
},

// Maneja @input: formatea y mueve el cursor al final
onInputCL(field, e) {
  const el = e && e.target ? e.target : null;
  const formatted = this.formatCLChilean(el ? el.value : this.form[field]);
  this.form[field] = formatted;
  if (el) {
    el.value = formatted;
    // Coloca el cursor al final (simple y robusto)
    this.$nextTick(() => {
      const pos = formatted.length;
      try { el.setSelectionRange(pos, pos); } catch(_) {}
    });
  }
},
    sanitizeDecimalForApi(v) {
  if (v === '' || v == null) return null;
  let t = String(v).trim();
  if (t.includes(',')) {
    t = t.replace(/\./g, ''); // quita miles
    t = t.replace(/,/g, '.'); // decimal a punto
  } else {
    const i = t.indexOf('.');
    if (i !== -1) {
      const left = t.slice(0, i + 1);
      const right = t.slice(i + 1).replace(/\./g, '');
      t = left + right;
    }
  }
  t = t.replace(/[^0-9.]/g, '');
  return t;
},
    // Normaliza el texto a un decimal con punto, aceptando coma chilena.
// - Si hay coma, se asume coma como separador decimal => se eliminan todos los puntos (miles) y se cambia , por .
// - Si no hay coma pero hay puntos, se deja solo el primer punto como decimal.
// - Se remueve cualquier carácter no numérico/decimal.
normalizeDecimalText(text) {
  let t = (text || '').toString().trim();

  if (t.includes(',')) {
    // Caso chileno: "1.234,56" -> "1234.56"
    t = t.replace(/\./g, '');   // quita miles
    t = t.replace(/,/g, '.');   // decimal a punto
  } else {
    // No hay coma. Mantener solo el primer punto como decimal.
    const firstDot = t.indexOf('.');
    if (firstDot !== -1) {
      // Elimina puntos extra después del primero
      const left = t.slice(0, firstDot + 1);
      const right = t.slice(firstDot + 1).replace(/\./g, '');
      t = left + right;
    }
  }
  // Quita todo lo que no sea dígito o punto
  t = t.replace(/[^0-9.]/g, '');
  // Evita múltiples puntos (si quedara alguno repetido)
  const parts = t.split('.');
  if (parts.length > 2) {
    t = parts[0] + '.' + parts.slice(1).join('').replace(/\./g, '');
  }
  return t;
},

handleDecimalInput(field, e) {
  const raw = e && e.target ? e.target.value : (e || '');
  this.form[field] = this.normalizeDecimalText(raw);
},

onPasteDecimal(field, e) {
  const text = (e.clipboardData || window.clipboardData).getData('text') || '';
  this.form[field] = this.normalizeDecimalText(text);
},

// Al salir del input, aplica el formateo que ya usas en el proyecto
formatDecimalOnBlur(field) {
  const v = this.form[field];
  if (v === '' || v == null) return;
  // Usa tu util existente para que mantenga el formato final (miles, etc.)
  this.$utilsService.onInputDecimal(field, this.form, String(v));
},
    async onEmpresaOrigenChange() {
      const empresa = this.form.EmpresaID;
      this.form.PasilloOrigenID = null;
      this.form.PlantaOrigenID = null;
      if (empresa) {
        this.plantaOptions = await miscService.getPlantasByEmpresaOptions(empresa);
        this.isEmpresaSelected = true;
      } else {
        this.plantaOptions = [];
        this.isEmpresaSelected = false;
      }
    },
    async onEmpresaDestinoChange() {
      const empresa = this.form.EmpresaDestinoID;
      this.form.PasilloDestinoID = null;
      this.form.PlantaDestinoID = null;
      if (empresa) {
        this.plantaDestinoOptions = await miscService.getPlantasByEmpresaOptions(empresa);
        this.isEmpresaDestinoSelected = true;
        // Obtener frag Folio propio de la empresa
        const empresaData = await empresaService.get(empresa);
        //console.log('Empresa data:', empresaData);
        this.folioEnabled = !!empresaData.swFolioPropio;

      } else {
        this.plantaOptions = [];
        this.isEmpresaDestinoSelected = false;
        this.folioEnabled = false;
      }
    },
    async onPlantaOrigenChange() {
      const empresa = this.form.EmpresaID;
      const planta = this.form.PlantaOrigenID;
      if (empresa && planta) {
        this.pasilloOptions = await miscService.getPasillosByEmpresaOptions(empresa, planta);
        this.isPlantaSelected = true;
      } else {
        this.pasilloOptions = [];
        this.isPlantaSelected = false;
      }
    },
    async onPlantaDestinoChange() {
      const empresa = this.form.EmpresaDestinoID;
      const planta = this.form.PlantaDestinoID;
      if (empresa && planta) {
        this.pasilloDestinoOptions = await miscService.getPasillosByEmpresaOptions(empresa, planta);
        this.isPlantaDestinoSelected = true;
      } else {
        this.pasilloDestinoOptions = [];
        this.isPlantaDestinoSelected = false;
      }
    },
    async onChangePais() {
      this.form.PasilloDestinoID = null;
      this.form.PlantaDestinoID = null;
      this.form.PasilloOrigenID = null;
      this.form.PlantaOrigenID = null;
      this.form.EmpresaID = null;
      this.form.EmpresaDestinoID = null;
      this.isEmpresaDestinoSelected = false;
      this.isPlantaSelected = false;
      this.isPlantaDestinoSelected = false;
      this.isEmpresaSelected = false;
      this.empresaOptions = await miscService.getEmpresasByPaisOptions(this.form.PaisID);
      this.isPaisSelected = true;
    },
    validateRequiredFields() {
      const requiredFields = [
        { field: 'PaisID', name: 'País' },
        { field: 'Fecha', name: 'Fecha' },
        { field: 'EmpresaID', name: 'Empresa Origen' },
        { field: 'PlantaOrigenID', name: 'Planta Origen' },
        { field: 'PasilloOrigenID', name: 'Pasillo Origen' },
        { field: 'ChoferID', name: 'Chofer' },
        { field: 'Patente', name: 'Patente Camión' },
        { field: 'PatenteCarro', name: 'Patente Carro' },
        { field: 'EmpresaDestinoID', name: 'Empresa Destino' },
        { field: 'PlantaDestinoID', name: 'Planta Destino' },
        { field: 'PasilloDestinoID', name: 'Pasillo Destino' },
        { field: 'NumeroHoja', name: 'Número de Hoja' },
        { field: 'GuiaTraslado', name: 'Guía de Traslado' },
        { field: 'MontoGuiaTraslado', name: 'Monto Guía Traslado' },
        { field: 'TicketInex', name: 'Ticket Inexlink' },
        { field: 'Peso', name: 'Peso Neto' },
        { field: 'PesoInex', name: 'Peso Neto Inexlink' },
        { field: 'MaterialID', name: 'Material Recibido' },
        { field: 'UomID', name: 'UOM' },
        { field: 'Precio', name: 'Precio' },
        { field: 'MonedaID', name: 'Moneda' },
        { field: 'PorcentajeProducto', name: 'Porcentaje Producto' }
      ];

      const missingFields = [];

      requiredFields.forEach(({ field, name }) => {
        const value = this.form[field];
        if (value === null || value === undefined || value === '' || value === 0) {
          missingFields.push(name);
        }
      });

      return missingFields;
    },
    async submitForm(skip = false) {
      if(skip){
        this.form.IsCompleted = !skip;
        const response = await ingresoService.create(this.form);
        return;
      }
      
      localStorage.setItem('hasUnsavedChanges', 'false'); 

      // Validar campos requeridos
      const missingFields = this.validateRequiredFields();
      
      if (missingFields.length > 0) {
        const fieldsList = missingFields.join(', ');
        Swal.fire({
          icon: "warning",
          title: "Campos requeridos",
          html: `Los siguientes campos son requeridos:<br><strong>${fieldsList}</strong>`,
          confirmButtonText: "Entendido"
        });
        return;
      }

      Swal.fire({
        title: this.$t('guardar'),
        text: this.$t('estas_seguro_guardar'),
        icon: 'info',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t('aceptar'),
        denyButtonText: this.$t('cancelar'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await ingresoService.create(this.form);
            if (!response) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: 'Ocurrió un error al crear el ingreso, intente nuevamente.'
              });
              return;
            }

            Swal.fire({
              title: "Creado correctamente",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              background: '#f8f9fa',
              customClass: {
                title: 'swal-title',
                icon: 'swal-icon',
              },
            });
            this.$router.push(`/ingresos/details/${response.ingresoID}`);
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.message
            });
          }
        }
        else if (result.isDenied) {
          Swal.close();
        }
      });
    },
    goToCrearChofer() {
      this.$router.push({ path: '/choferes/create-modal' });
    },
    onChoferCreated() {
      this.showChoferModal = false;
      // Recarga la lista de choferes si es necesario
      this.loadChoferOptions();
    },
    async loadChoferOptions() {
       this.choferOptions = await miscService.getChoferesOptions();
    },
    onlyNumbers(event) {
  const ctrl = ['Backspace','Delete','Tab','Enter','ArrowLeft','ArrowRight','Home','End'];
  if (ctrl.includes(event.key)) return;

  // Solo dígitos y coma (el punto lo agregamos nosotros como miles)
  if (!/[0-9,]/.test(event.key)) {
    event.preventDefault();
    return;
  }

  const v = event.target.value || '';
  if (event.key === ',' && v.includes(',')) {
    // una sola coma decimal
    event.preventDefault();
  }
}

  },
};
</script>
<style>
.el-table.table-dark {
  background-color: #4d4c4c;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr {
  background-color: #4d4c4c;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf {
  border-bottom: none;
}

.row.card-ing {
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 0.375rem;
  padding: 30px 0px;
  margin-bottom: 20px;
}

.ai-c {
  align-content: center;
}

input#patente {
  text-transform: uppercase;
}

input#patente::placeholder {
  text-transform: none;
}
</style>
